var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React, { useRef, useEffect } from 'react';
import { injectIntl } from 'react-intl';
import Icon from '../Icon';
import getByPath from 'lodash/get';
import marked from 'marked';
import translate from '../../lib/utils/translate';

var Alert = function Alert(_ref) {
  var id = _ref.id,
      values = _ref.values,
      icon = _ref.icon,
      level = _ref.level,
      defaultMessage = _ref.defaultMessage,
      _ref$scrollIntoView = _ref.scrollIntoView,
      scrollIntoView = _ref$scrollIntoView === undefined ? true : _ref$scrollIntoView,
      onDiscard = _ref.onDiscard;

  if (!icon && level === 'success') icon = 'check-circle';
  if (!icon && level === 'info') icon = 'info-circle';
  if (!icon && level === 'warning') icon = 'exclamation-triangle';
  if (!icon && level === 'danger') icon = 'exclamation-triangle';

  useEffect(function () {
    return function () {
      return onDiscard && onDiscard();
    };
  }, []);

  var ref = useRef(null);
  useEffect(function () {
    return scrollIntoView && ref ? ref.current.scrollIntoView() : function () {};
  }, [ref, scrollIntoView]);

  var messages = React.createElement(FormattedMessageFixed, {
    id: id,
    level: level,
    defaultMessage: defaultMessage,
    values: _extends({}, values)
  });

  if (Array.isArray(id)) {
    messages = id.map(function (i, k) {
      return React.createElement(FormattedMessageFixed, {
        id: i,
        level: level,
        defaultMessage: defaultMessage,
        values: _extends({}, values),
        key: k
      });
    });
  }

  return React.createElement(
    'div',
    { className: 'Alert level-' + level + ' icon', ref: ref },
    icon && React.createElement(
      'div',
      { className: 'icon' },
      React.createElement(Icon, { icon: icon })
    ),
    React.createElement(
      'div',
      { className: 'content' },
      messages
    )
  );
};

var FormattedMessageFixed = injectIntl(function (_ref2) {
  var intl = _ref2.intl,
      level = _ref2.level,
      props = _objectWithoutProperties(_ref2, ['intl', 'level']);

  var translation = translate(_extends({}, props, { id: getKey(intl, props.id, level) }), intl);

  // Translate util will in some cases return an object instead of a string, that cant be passed to marked.
  if (typeof translation !== 'string') return React.createElement(
    'div',
    null,
    translation
  );

  return React.createElement('div', {
    dangerouslySetInnerHTML: {
      __html: marked(translation)
    }
  });
});

export var getKey = function getKey(intl, key) {
  var level = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'danger';

  while (!intl.messages[key] && key !== 'alert_message.' + level) {
    console.error('Missing translation for \'' + key + '\'');
    var parts = key.split('.');
    key = parts.splice(0, parts.length - 1).join('.');
  }

  return key;
};

export var createAlertId = function createAlertId(error) {
  var level = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'danger';

  var code = getByPath(error, 'payload.data.Code') || getByPath(error, 'payload.value.response.data.Code');
  var details = Object.keys(getByPath(error, 'payload.data.Details') || getByPath(error, 'payload.value.response.data.Details') || {}).map(function (k) {
    return k.toLowerCase();
  }).sort();

  return ['alert_message', level, getByPath(error, 'payload.data.Issues[0]'), getByPath(error, 'payload.data.Code') || getByPath(error, 'payload.value.response.data.Code'), Object.keys(getByPath(error, 'payload.data.Details') || {})[0] || Object.keys(getByPath(error, 'payload.value.response.data.Details') || {})[0], getByPath(error, 'keys[0]'), code, getByPath(error, 'type')].concat(_toConsumableArray(details)).filter(function (p) {
    return !!p;
  }).join('.').toLowerCase();
};

export default Alert;